import styles from "./CountBadge.module.css";

// A count waiting on the operator, or nothing. Never a zero: "nothing is waiting" is what
// an ABSENT badge says, and a 0 reads as something to look at. ``outline`` is the same
// blue unfilled, for a count beside a filled one that means something else (unread
// answers beside open agent feedback).
export const CountBadge = ({
  count,
  className,
  outline = false,
}: {
  count: number;
  className?: string;
  outline?: boolean;
}) =>
  count > 0 ? (
    <span
      className={[styles.badge, outline ? styles.outline : "", className ?? ""]
        .filter(Boolean)
        .join(" ")}
    >
      {count}
    </span>
  ) : null;
